import { Component, OnInit } from '@angular/core';
import { FnModalService, FnTableConfig, FnTableMetaData, FnToasterService, FnUtilService, TABLE_ACTION_TYPE, TableAction } from 'foundation';
import { EOSchemaTeam } from '../../../modal/entity.modal';
import { Subject } from 'rxjs';
import { PosHttpService } from '../../../services/pos.http.service';
import { SchemaTeamModelComponent } from './schema-team-model/schema-team.component';

@Component({
  selector: 'app-schema',
  templateUrl: './schema.component.html',
  styleUrl: './schema.component.scss'
})
export class SchemaComponent implements OnInit {
  constructor(private posHttpSvcs: PosHttpService, private toastr: FnToasterService, private fnModalSvcs: FnModalService) {
  }
  ngOnInit(): void {
    this.loadData();
  }
  showData = false;

  uiMap = {
    isDataLoaded: false,
  };

  config: FnTableConfig = {
    uniqueKey: 'primaryKey',
    defaultSortKey: 'primaryKey',
    tableAction: new Subject<TableAction>(),
  };

  rowMetaArray: FnTableMetaData[] = [
    {
      key: 'primaryKey',
      description: 'Primary Key',
      isHidden: true,
      isSortable: true,
      type: 'number',
    },
    {
      key: 'schemaName',
      description: 'Schema Name',
      type: 'string',
      isSortable: true,
    }
  ];

  schemaArray: EOSchemaTeam[] = [];


  loadData() {
    this.posHttpSvcs.authGet('v1/ui/loadEOSchema', 'loadEOSchema').subscribe((resp: any) => {
      if (resp.isError) {
        this.toastr.error('Invalid Schema Data ⚠️');
        return;
      }
      this.schemaArray = resp.data;
      this.showData = false;
      this.refreshTableData();
      this.uiMap.isDataLoaded = true;
    });
  }
  updateRowAction(event: EOSchemaTeam) {
    const schemaModal = this.fnModalSvcs.openCustomModal(SchemaTeamModelComponent, {
      data: {
        eoSchema: event,
      },
      hasBackdrop: true,
      width: '500px',
    })
    schemaModal.afterClosed().subscribe((objectHash) => {
      if (objectHash != undefined) {
        this.addUpdateschemaModal(objectHash);
      }
    });
  }

  deleteRowAction(event: EOSchemaTeam) {
    const dialogRef = this.fnModalSvcs.openConfirmModal({
      isConformationMdl: true,
      content: 'Are you sure you want to delete Schema ?',
      type: 'danger',
    });
    dialogRef.afterClosed().subscribe(doAction => {
      if (doAction) {
        this.posHttpSvcs.authDeleteWithBody('v1/ui/deleteSchema', event.primaryKey, event).subscribe(resp => {
          this.loadData();
        })
      }
    });

  }

  openActionMdl() {
    const schemaModal = this.fnModalSvcs.openCustomModal(SchemaTeamModelComponent, {
      data: {
      },
      hasBackdrop: true,
      width: '500px',
    })
    schemaModal.afterClosed().subscribe((objectHash) => {
      if (objectHash != undefined) {
        this.addUpdateschemaModal(objectHash);
      }
    });
  }

  addUpdateschemaModal(objectHash: any) {
    this.posHttpSvcs.authPut('v1/ui/saveSchema', 'saveSchema', objectHash).subscribe(resp => {
      if (resp.isError) {
        this.toastr.error(' Schema is not added ⚠️');
        return;
      } else {
        this.toastr.success("Schema added successfully");
        this.loadData();
      }
    })

  }

  refreshTableData() {
    if (this.config.tableAction.closed) {
      this.config.tableAction = new Subject<TableAction>();
    }
    this.config.tableAction.next({
      data: this.schemaArray,
      action: TABLE_ACTION_TYPE.REFRESH,
    });
  }
}